import { useEffect, useRef } from "react";

const useInactivityTimer = (onLogout) => {
  const timerRef = useRef(null);

  const getTimeoutMinutes = () => {
    const stored = localStorage.getItem("inactivityTimeout");
    return stored ? parseInt(stored, 10) : 30;
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    const minutes = getTimeoutMinutes();
    if (!minutes || minutes <= 0) return;
    timerRef.current = setTimeout(() => {
      onLogout();
    }, minutes * 60 * 1000);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach(e => window.addEventListener(e, resetTimer));
    resetTimer();

    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
};

export default useInactivityTimer;
